import React from 'react';
import Icon from '../../../components/AppIcon';

const PermitHeader = ({ permit }) => {
  const getStatusColor = (status) => {
    const colors = {
      'Active': 'bg-success/10 text-success border-success/20',
      'Pending Approval': 'bg-warning/10 text-warning border-warning/20',
      'Expired': 'bg-error/10 text-error border-error/20',
      'Closed': 'bg-muted text-muted-foreground border-border',
      'Extended': 'bg-accent/10 text-accent border-accent/20'
    };
    return colors?.[status] || 'bg-muted text-muted-foreground border-border';
  };

  const getPriorityColor = (priority) => {
    const colors = {
      'High': 'text-error',
      'Medium': 'text-warning',
      'Low': 'text-success'
    };
    return colors?.[priority] || 'text-muted-foreground';
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-card">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 mb-6">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h1 className="text-2xl font-bold text-foreground">Permit #{permit?.permitNumber}</h1>
            <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(permit?.status)}`}>
              <span className="w-2 h-2 rounded-full bg-current"></span>
              {permit?.status}
            </span>
          </div>
          <p className="text-muted-foreground text-sm">{permit?.workType}</p>
        </div>
        
        <div className="flex flex-wrap gap-2">
          <button className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors text-sm font-medium">
            <Icon name="Download" size={16} />
            Print Permit
          </button>
          <button className="inline-flex items-center gap-2 px-4 py-2 bg-card border border-border text-foreground rounded-lg hover:bg-accent/10 transition-colors text-sm font-medium">
            <Icon name="Edit" size={16} />
            Edit Details
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Calendar" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Valid Period</p>
            <p className="text-sm font-medium text-foreground">{permit?.startDate}</p>
            <p className="text-xs text-muted-foreground">to {permit?.endDate}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
            <Icon name="MapPin" size={20} color="var(--color-accent)" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Location</p>
            <p className="text-sm font-medium text-foreground">{permit?.location}</p>
            <p className="text-xs text-muted-foreground">{permit?.area}</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-warning/10 flex items-center justify-center flex-shrink-0">
            <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Priority Level</p>
            <p className={`text-sm font-medium ${getPriorityColor(permit?.priority)}`}>{permit?.priority}</p>
            <p className="text-xs text-muted-foreground">{permit?.hazardLevel} Risk</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center flex-shrink-0">
            <Icon name="User" size={20} color="var(--color-success)" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Issued By</p>
            <p className="text-sm font-medium text-foreground">{permit?.issuedBy}</p>
            <p className="text-xs text-muted-foreground">{permit?.issueDate}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PermitHeader;